export enum PaymentMethod {
    BANK_DRAFT = "1",
    CASH = "2",
}
